import React from 'react'
import {Row, Col, Divider, Input} from 'antd';
import './buscador-lateral.scss';

const Search = Input.Search;

const BuscadorLateral = props =>{
    const {search, items} = props;
    const {onSearch, loading, enterButton, onChange, placeholder} = search;

    return (
    <Row>
        <Col className='container-list' style={{
             width: "348px", 
             maxWidth: "348px",
             overflow: "hidden",
             height: "100vh"
        }}>
            <Row style={{ padding: "23px"}}>
                <Search size="small" 
                    onSearch={onSearch} 
                    placeholder={placeholder}
                    loading={loading} 
                    enterButton={enterButton} 
                    onChange={onChange}>
                    
                </Search>
                
            </Row>

            <Divider style={{
                marginTop: "0",
                marginBottom: "0"
            }}></Divider>

            <Row style={{
                overflowY: "auto",
                overflowX: "hidden",
                height: "calc(100vh - 151px)",
                paddingBottom: "20px",
                flexFlow: "column"

            }}>
                {items}
            </Row>
        </Col>
    </Row>
    );
}

export {BuscadorLateral};